const config = process.env.GATSBY_CONFIGURATION || "boleron";

// eslint-disable-next-line import/no-dynamic-require
const activeProductsConfig = require(`./${config}`).default;

export const GATSBY_CONFIGURATION = config;

export default activeProductsConfig;
